<template>
   <component :is="loadComponent()" :template="'default'"></component>
</template>

<script>
import { defineAsyncComponent } from "vue";
export default {
 methods: {
        loadComponent() {
            return defineAsyncComponent(() =>
                import(`@/default/components/login.vue`)
            );
        },
    },
}
</script>
